const _excluded = ["balice", "transformOriginAnimation", "transformOrigin", "size"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactDOM from 'react-dom';
import { FullContainerRelativeModal } from "./full-container-relative.modal";
import { elementViewportOrigin } from "./full-container.utils";
import "./full-container-relative.modal.style.scss";
// TODO refactor and renew all this component with the /dialog one but without losing animation funcionality etc

export const FullContainerModal = props => {
  const {
      balice,
      transformOriginAnimation = true,
      transformOrigin,
      size
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const ref = React.useRef(null);
  const origin = React.useCallback(() => {
    if (transformOriginAnimation && !transformOrigin) {
      var _balice$current, _ref$current;
      const element = (_balice$current = balice === null || balice === void 0 ? void 0 : balice.current) !== null && _balice$current !== void 0 ? _balice$current : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.parentElement;
      if (element) {
        return elementViewportOrigin(element);
      } else return '50% 50%';
    } else return '50% 50%';
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "full-container-modal-relative-balice",
    ref: ref
  }), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(FullContainerRelativeModal, _extends({}, rest, {
    size: size,
    transformOrigin: transformOrigin !== null && transformOrigin !== void 0 ? transformOrigin : origin
  })), document.body));
};
FullContainerModal.defaultProps = {
  transformOriginAnimation: true
};